import { z } from "zod";
import { zObj } from "./zodWrapper.js";
const DataObject = z.object({
    label: z.string(),
    object: z.any(),
});
export const SubmitErrorEventArgs = zObj({
    message: z.string(),
    dataObjects: z.array(DataObject),
});
//# sourceMappingURL=debug.js.map